// extracted by mini-css-extract-plugin
export default {"title":"MainPage_title__2+M6o","section-box":"MainPage_section-box__0KzhK","introduce-box":"MainPage_introduce-box__kG6Nh","introduce-img-box":"MainPage_introduce-img-box__9hm5r"};